export default __webpack_public_path__ + "static/media/titulo_reeducacion_alimentaria.39e7a495.jpg";